module.exports = __webpack_public_path__ + "static/img/gzh.3f89d3f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gzh.png
// module id = Xq3r
// module chunks = 14